import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarRightHide12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 2H1.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H7zm5 .5A1.5 1.5 0 0 0 10.5 1h-9A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5zM3.347 4.584a.5.5 0 1 1 .707-.708l1.768 1.768.354.354-.354.353L4.054 8.12a.5.5 0 0 1-.707-.707l1.414-1.414z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide12Filled);
